/**
 * A shortened fingerprint (shortHash) that may break only at its ellipsis.
 *
 * A fingerprint is compared by eye, and one split in an arbitrary place reads
 * as two values, so each half stays whole (.mono-short, review 5, design-6).
 * Kept whole as one piece it could not fit a phone: the signer's finished
 * card held its table at 308px, through the card's border at 360px and past
 * a 320px screen, and Technical details on the document page ran 4px past
 * 320px (review 6, design-1). Where it has to break it reads as the start
 * and the end of one value; where there is room it stays on one line. The
 * element around it carries .mono, not .mono-short.
 */
export function Fingerprint({ hash }: { hash: string }) {
  const at = hash.indexOf('\u2026')
  if (at < 0) return <span className="mono-short">{hash}</span>
  return (
    <>
      <span className="mono-short">{hash.slice(0, at + 1)}</span>
      <wbr />
      <span className="mono-short">{hash.slice(at + 1)}</span>
    </>
  )
}
